namespace TabAurous.Inventory {
    export interface BranchOutItemsForm {
        TransId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        PartyId: Serenity.IntegerEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        DesignId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        DesignCode: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: Serenity.LookupEditor;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        StampId: Serenity.LookupEditor;
        ProductSizeId: CommonProductSizeLookup;
        HasBom: Serenity.BooleanEditor;
        MetalId: Serenity.LookupEditor;
        Attribute: Serenity.StringEditor;
        KaratId: Serenity.LookupEditor;
        Purity: Serenity.DecimalEditor;
        MetalColorId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: StoneSieveLookup;
        GroupSieveId: StoneSieveLookup;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        Lab: Serenity.LookupEditor;
        CertificateNo: Serenity.StringEditor;
        Hallmark: Serenity.LookupEditor;
        HUID: Serenity.StringEditor;
        CalcOnId: Serenity.LookupEditor;
        CalcUnitId: Serenity.LookupEditor;
        HSN: Serenity.LookupEditor;
        TaxCode: Serenity.LookupEditor;
        DepartmentId: Serenity.IntegerEditor;
        Line_No: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        Pieces: Serenity.IntegerEditor;
        ExportPieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        PureWeight: WeightEditor;
        NetWeight: WeightEditor;
        UnitRate: Serenity.DecimalEditor;
        MetalAmount: Serenity.DecimalEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: WeightEditor;
        StoneRate: AmountEditor;
        StoneAmount: Serenity.DecimalEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: WeightEditor;
        DiamondAmount: Serenity.DecimalEditor;
        OtherPieces: Serenity.IntegerEditor;
        OtherWeight: WeightEditor;
        OtherRate: AmountEditor;
        OtherAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        UnitLabour: Serenity.DecimalEditor;
        FancyCharges: AmountEditor;
        OtherCharges: AmountEditor;
        GrossAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        CCNetAmount: Serenity.DecimalEditor;
        MF: Serenity.DecimalEditor;
        MFAmount: Serenity.DecimalEditor;
        UnitCost: Serenity.DecimalEditor;
        WstPer: Serenity.DecimalEditor;
        WstWt: WeightEditor;
        Remarks: Serenity.StringEditor;
        IsDisabled: Serenity.BooleanEditor;
        ServerDate: Serenity.DateEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        SpecialRemark: Serenity.StringEditor;
        UserDescription: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        DeliveryDate: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        BagStatus: Serenity.StringEditor;
        CostMethodId: Serenity.EnumEditor;
        ImageName: Serenity.ImageUploadEditor;
        BOMDetails: BranchOutBOMEditor;
        LaborDetails: BranchOutLaborEditor;
    }

    export class BranchOutItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.BranchOutItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!BranchOutItemsForm.init)  {
                BranchOutItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = CommonProductSizeLookup;
                var w5 = s.BooleanEditor;
                var w6 = s.DecimalEditor;
                var w7 = StoneSieveLookup;
                var w8 = WeightEditor;
                var w9 = AmountEditor;
                var w10 = s.DateEditor;
                var w11 = s.EnumEditor;
                var w12 = s.ImageUploadEditor;
                var w13 = BranchOutBOMEditor;
                var w14 = BranchOutLaborEditor;

                Q.initFormType(BranchOutItemsForm, [
                    'TransId', w0,
                    'TransItemId', w0,
                    'VoucherTypeId', w1,
                    'PartyId', w1,
                    'BagNo', w0,
                    'SKU', w0,
                    'ItemTypeId', w1,
                    'ProductId', w0,
                    'DesignId', w0,
                    'ProductTypeId', w2,
                    'ProductCode', w0,
                    'ProductName', w0,
                    'DesignCode', w0,
                    'AttributeId', w0,
                    'CategoryId', w3,
                    'SubCategoryId', w2,
                    'BrandId', w2,
                    'SuperTypeId', w2,
                    'CollectionId', w2,
                    'StampId', w2,
                    'ProductSizeId', w4,
                    'HasBom', w5,
                    'MetalId', w2,
                    'Attribute', w0,
                    'KaratId', w2,
                    'Purity', w6,
                    'MetalColorId', w2,
                    'ShapeId', w2,
                    'StoneColorId', w2,
                    'QualityId', w2,
                    'StoneSizeId', w2,
                    'SieveId', w7,
                    'GroupSieveId', w7,
                    'StoneCutId', w2,
                    'StonePolishId', w2,
                    'StoneSymmetryId', w2,
                    'StoneFluorescenceId', w2,
                    'StoneCuletId', w2,
                    'StoneGirdleId', w2,
                    'StoneTable', w0,
                    'StoneDepth', w0,
                    'LotNo', w0,
                    'Lab', w2,
                    'CertificateNo', w0,
                    'Hallmark', w2,
                    'HUID', w0,
                    'CalcOnId', w2,
                    'CalcUnitId', w2,
                    'HSN', w2,
                    'TaxCode', w2,
                    'DepartmentId', w1,
                    'Line_No', w0,
                    'RefNo', w0,
                    'Pieces', w1,
                    'ExportPieces', w1,
                    'Weight', w8,
                    'PureWeight', w8,
                    'NetWeight', w8,
                    'UnitRate', w6,
                    'MetalAmount', w6,
                    'StonePieces', w1,
                    'StoneWeight', w8,
                    'StoneRate', w9,
                    'StoneAmount', w6,
                    'DiamondPieces', w1,
                    'DiamondWeight', w8,
                    'DiamondAmount', w6,
                    'OtherPieces', w1,
                    'OtherWeight', w8,
                    'OtherRate', w9,
                    'OtherAmount', w6,
                    'NetAmount', w6,
                    'UnitLabour', w6,
                    'FancyCharges', w9,
                    'OtherCharges', w9,
                    'GrossAmount', w6,
                    'CCGrossAmount', w6,
                    'CCNetAmount', w6,
                    'MF', w6,
                    'MFAmount', w6,
                    'UnitCost', w6,
                    'WstPer', w6,
                    'WstWt', w8,
                    'Remarks', w0,
                    'IsDisabled', w5,
                    'ServerDate', w10,
                    'RefTransItemId', w0,
                    'RefTransId', w0,
                    'Remark', w0,
                    'SpecialRemark', w0,
                    'UserDescription', w0,
                    'AckStatus', w1,
                    'DeliveryDate', w10,
                    'CompanyId', w1,
                    'BagStatus', w0,
                    'CostMethodId', w11,
                    'ImageName', w12,
                    'BOMDetails', w13,
                    'LaborDetails', w14
                ]);
            }
        }
    }
}
